import { render, staticRenderFns } from "./FoodCourtOrders.vue?vue&type=template&id=6ebe62a0&scoped=true"
import script from "./FoodCourtOrders.vue?vue&type=script&lang=js"
export * from "./FoodCourtOrders.vue?vue&type=script&lang=js"
import style0 from "./FoodCourtOrders.vue?vue&type=style&index=0&id=6ebe62a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebe62a0",
  null
  
)

export default component.exports